module.exports = __webpack_public_path__ + "img/boss1.a632a835.png";